<template>
  <el-form :model="model" :disabled="!!disabled || isLoading">
    <el-row>
      <el-col :span="24">
        <form-item
          prop="frequency"
          :label="$t('CampaignFormExecutionSettings_Campaign')"
          :hint="$t('CampaignFormExecutionSettings_Campaign_Hint')"
        >
          <el-autocomplete
            :placeholder="
              $t('CampaignFormExecutionSettings_Campaign_Placeholder')
            "
            clearable
            value-key="value"
            v-model="campaign"
            :fetch-suggestions="autocompleteSearch"
            :debounce="300"
            @select="handleSelectAttr"
            @clear="handleClear"
          >
          </el-autocomplete>
        </form-item>
      </el-col>
    </el-row>
    <el-row v-if="campaign">
      <el-col :span="3">
        <form-item
          prop="time"
          :label="$t('CampaignFormExecutionSettings_Field_Time')"
        >
          <el-time-picker
            v-model="triggerTime"
            format="HH:mm"
            value-format="HH:mm"
            clearable
            :placeholder="
              $t('CampaignFormExecutionSettings_Field_Time_Placeholder')
            "
          />
        </form-item>
      </el-col>
      <el-col :span="3">
        <form-item :label="$t('CampaignFormExecutionSettings_Field_Timezone')">
          <span class="timezone">{{ $store.state.app.project.timezone }}</span>
        </form-item>
      </el-col>
    </el-row>
    <el-row v-if="triggerTime">
      <el-col :span="24" class="warning-message">
        <icon glyph="warning" />
        <span style="margin-left: 5px">
          {{ $t('CampaignFormExecutionSettings_Field_Time_Warning') }}
        </span>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'CampaignExecutionSettings',
  components: { FormItem },
  props: {
    model: {
      type: Object,
      required: true,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      isLoading: false,
      campaign: '',
      triggerTime: undefined
    }
  },
  computed: {
    campaignsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns`
      })
    }
  },
  mounted() {
    this.loadCurrentCampaign()
    this.loadTriggeringSchedule()
  },
  methods: {
    autocompleteSearch(queryString, cb) {
      let params = {
        sort: '-last_modified,-id',
        trigger_type: 'api',
        expand: 'title,id',
        status_type: 'draft_live_future',
        title: queryString
      }
      RestApi({
        ...this.campaignsEndpoint,
        params: params
      }).then(({ data }) => {
        const list = data.map(item => {
          return {
            id: item.id,
            value: item.title
          }
        })
        cb(list)
      })
    },
    loadCurrentCampaign() {
      if (!this.model.triggering.campaign_id) {
        return
      }
      let currentIndex = this.options.findIndex(
        item => item.id === this.model.triggering.campaign_id
      )
      if (currentIndex !== -1) {
        return
      }
      let params = {
        trigger_type: 'api',
        expand: 'title,id',
        id: this.model.triggering.campaign_id
      }

      RestApi({
        ...this.campaignsEndpoint,
        params: params
      })
        .then(({ data, headers }) => {
          this.isLoading = false
          this.campaign = data[0].title
        })
        .catch(error => {
          this.isLoading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    loadTriggeringSchedule() {
      if (this.model.triggering.at) {
        this.triggerTime = this.model.triggering.at
      }
    },
    handleSelectAttr(item) {
      this.model.triggering.campaign_id = item.id
    },
    handleClear() {
      this.model.triggering.campaign_id = ''
    }
  },
  watch: {
    triggerTime: function(newValue) {
      this.model.triggering.at = newValue
    }
  }
}
</script>

<style scoped lang="scss">
.timezone {
  line-height: 40px;
}
.warning-message {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/automations/components/CampaignExecutionSettings.vue